import React from "react";
import Slider from "react-slick";
// import "./index.css";

class SlickCarousel extends React.Component {
  render() {
    var settings = {
      dots: false,
      slidesToShow: this.props.slidesToShow ? this.props.slidesToShow : 3,
      slidesToScroll: 1,
      arrows: true,
    };
    return (
      <div className="container">
        <Slider {...settings}>{this.props.children}</Slider>
      </div>
    );
  }
}
export default SlickCarousel;
